import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SkeletonComponent } from '../skeleton/skeleton';

@Component({
  selector: 'nr-resource-skeleton',
  imports: [SkeletonComponent],
  templateUrl: './resource-skeleton.html',
  styleUrl: './resource-skeleton.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResourceSkeletonComponent {}
